import React from 'react';
import './index.css';
import User from './user.js';
// import Tab from './tabs.js';
import Area from './area.js';
import Pass from './pass.js';
import { Route } from 'react-router-dom';

class Content extends React.Component {
  constructor(){
    super();
    this.state = {
      typeList : false
    }
  }
  render(){
    const { parent, menu } = this.props;
    let done = true;
    let tab = '';
    switch(menu) {
      case '/manage/user':
        tab = User;
        break;
      case '/manage/area':
        tab = Area;
        break;
      case '/manage/area/pass':
        tab = Pass;
        break;
    }
    return (
      <div id="manageMain" className="content-main">
        { done ?
          <Route path={ window.path } component={ tab } /> :
          <div>
          </div>
        }
      </div>
    )
  }
}
export default Content;



// WEBPACK FOOTER //
// ./src/component/manage/content.js